<template>
  <div class="agency-contract">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"> <span></span>{{ $t('contractAgency.baseTitle') }} </div>
        </template>
        <div class="collapse-content">
          <base-info-form
            @rateChange="rateChange"
            @settleRate="settleRate"
            @latestDate="latestDateChange"
            ref="baseInfoForm"
            :contractStatus="contractStatus"
            :disabled="disabled"
            :defaultData="baseDefault"
            :initFlag="initFlag"
            @changeBusinessType="changeBusinessType"
          ></base-info-form>
        </div>
      </el-collapse-item>
      <el-tabs type="border-card" class="my-card">
        <el-tab-pane :label="$t('contractAgency.productTab.title')">
          <product-info
            :defaultData="baseDefault"
            :exchangeRate="exchangeRate"
            :salesExchangeRate="salesExchangeRate"
            :isEdit="!disabled"
            ref="productTable"
            :contractStatus="contractStatus"
            :defaultBusinessType="defaultBusinessType"
          ></product-info>
        </el-tab-pane>
        <el-tab-pane :label="$t('contractAgency.moneyRateTab.title')">
          <money-rate-form
            :defaultData="baseDefault.orderInterest || {}"
            :exchangeRate="settleCurrencyRate"
            :disabled="disabled"
            ref="moneyRateForm"
          ></money-rate-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('contractAgency.transportTab.title')">
          <transport-form
            :defaultData="baseDefault.orderDelivery || {}"
            :disabled="disabled"
            :exchangeRate="settleCurrencyRate"
            :lastestReceiveProductDay="lastestReceiveProductDay"
            ref="transportForm"
          ></transport-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('contractAgency.relationTab.title')">
          <relation-info
            ref="relationInfo"
            :disabled="disabled"
            :contractNo="baseDefault.contractNo"
            :defaultData="baseDefault.orderContractRelationshipList || []"
          ></relation-info>
        </el-tab-pane>
      </el-tabs>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre"> <span></span>{{ $t('contractAgency.fileTitle') }} </div>
        </template>
        <div class="collapse-content">
          <upload
            v-bind:isShow="!disabled"
            @upload="handleUpload"
            :tableData="baseDefault.attachmentList || []"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!--TODO 根据不同状态展示不同按钮-->
      <el-button
        v-if="!disabled"
        type="primary"
        :loading="load"
        @click="handleSave"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.save') }}</el-button
      >
      <el-button
        v-if="!disabled"
        type="primary"
        :loading="load"
        v-hasPermi="['2021042916051742109']"
        @click="handleSubmit"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.approval') }}</el-button
      >
      <el-button
        v-if="baseDefault.contractStatus == 'ZT03'"
        v-hasPermi="['2021042916054353611']"
        type="primary"
        @click="handleCopy"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.copy') }}</el-button
      >
      <el-button
        v-if="baseDefault.contractStatus == 'ZT06'"
        v-hasPermi="['2021042916045043601']"
        type="danger"
        :loading="load"
        @click="handleDelete"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.delete') }}</el-button
      >
      <el-button
        v-if="baseDefault.contractStatus == 'ZT03'"
        v-hasPermi="['2021042916060526797']"
        type="primary"
        @click="handlePrint"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.print') }}</el-button
      >
      <!-- 代理合同已生效时会分别生成采销合同，根据最新需求关闭合同在采销合同实现，故取消代理合同关闭功能 -->
      <el-button
        v-if="baseDefault.contractStatus == 'ZT03'"
        v-hasPermi="['2021042916063210742']"
        type="primary"
        @click="operateStatus(2)"
        class="fixed-bottom-btn"
        >{{ $t('salePurchase.revert') }}</el-button
      >
      <!-- 已关闭的代理合同可进行激活操作 -->
      <el-button
        v-if="baseDefault.contractStatus == 'ZT07'"
        type="primary"
        @click="operateStatus(1)"
        class="fixed-bottom-btn"
        >{{ $t('salePurchase.operateStatusOpen') }}</el-button
      >
      <!-- 风控撤销审批操作 -->
      <!-- 确认撤销 -->
      <el-button
        v-if="baseDefault.contractStatus == 'ZT022'"
        type="primary"
        @click="operateRevert(1)"
        class="fixed-bottom-btn"
        >{{ $t('salePurchase.confirmRevert') }}</el-button
      >
      <!-- 驳回撤销 -->
      <el-button
        v-if="baseDefault.contractStatus == 'ZT022'"
        type="primary"
        @click="operateRevert(0)"
        class="fixed-bottom-btn"
        >{{ $t('salePurchase.cancelRevert') }}</el-button
      >
    </div>
    <print-dialog ref="printDialog" :contractNo="this.$route.query.contractNo"></print-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import baseInfoForm from './components/base-info-from';
  import productInfo from './components/product-info';
  import moneyRateForm from './components/money-rate-form';
  import transportForm from './components/transport-form';
  import relationInfo from './components/relation-info';
  import printDialog from './components/printDialog';
  import upload from '@/components/upload';
  import AGENCY_API from '@/api/agencyContract/index';
  import { dateFormat } from '@/filters/index';
  import { handlePath } from './js';
  import { CHECK_EXTERNAL_CONTRACTNO } from './components/checkExternalContractNo';

  export default {
    data() {
      return {
        load: false,
        activeNames: ['1', '2'],
        uploadTableData: [],
        baseDefault: {},
        exchangeRate: 1,
        salesExchangeRate: 1,
        settleCurrencyRate: 1, //结算货币默认取销售货币，汇率跟销售汇率走
        // 默认禁用：新增、草稿和已驳回启用编辑
        disabled: true,
        lastestReceiveProductDay: '', // 最晚收获日
        contractStatus: '', //合同状态
        defaultBusinessType: '',
        contractStatusList: ['ZT061', 'ZT051'], // 草稿、已驳回 ,修订中，修改已驳回 可以修改"
        initFlag: false,
      };
    },
    components: {
      baseInfoForm,
      productInfo,
      moneyRateForm,
      transportForm,
      relationInfo,
      upload,
      printDialog,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {
      this.initBase();
    },
    methods: {
      handlePath,
      latestDateChange(date) {
        this.lastestReceiveProductDay = date;
      },
      //关闭 撤销 激活
      operateStatus(type) {
        //0-关闭 1-激活 2-撤销
        let params = {
          id: this.$route.query.id,
          operateFlag: type,
        };
        this.$axios.post(AGENCY_API.UPDATE_OTDER_STATUS, params).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            this.initBase();
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //风控撤销操作
      operateRevert(type) {
        //approvaResult  审批状态 1通过 0不通过
        let params = {
          id: this.$route.query.id,
          approvaResult: type,
        };
        this.$axios.post(AGENCY_API.POST_REVERT_API, params).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            // this.cancel(true);
            //确认撤销后，刷新页面可编辑
            if (type == 1) {
              let query = this.$router.history.current.query;
              let path = this.$router.history.current.path;
              //对象的拷贝
              let newQuery = JSON.parse(JSON.stringify(query));
              newQuery.isEdit = 'false';
              this.$router.push({ path, query: newQuery });
            }
            this.initBase();
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //业务性质类型
      changeBusinessType(value) {
        this.defaultBusinessType = value;
      },
      rateChange(exchangeRate) {
        //采销汇率
        if (exchangeRate.purchaseCurrencyCode) {
          this.exchangeRate = exchangeRate.purchaseCurrencyCode;
        } else {
          this.salesExchangeRate = exchangeRate.saleCurrencyCode;
        }
      },
      settleRate(settleCurrencyRate) {
        //结算汇率
        this.settleCurrencyRate = settleCurrencyRate;
      },
      initBase() {
        const userInfo = this.userInfo;
        const contractNo = this.$route.query.contractNo;
        const name = this.$route.name;
        if (name === 'agencyContractAdd') {
          this.disabled = false;
        }
        if (contractNo) {
          // 请求详情
          this.initFlag = true;
          const url = AGENCY_API.AGENCY_CONTRACT_DETAIL + contractNo;
          this.$axios.get(url).then((res) => {
            if (res.data.code === 0) {
              const returnData = Object.assign({}, res.data.data);
              if (name === 'agencyContractAdd') {
                // 复制时：删除合同编号
                delete returnData.contractNo;
                delete returnData.id;
                returnData.contractStatus = '';
                returnData.orderContractRelationshipList = [];
                // 复制时，将行信息中的checkFlag是否有后续执行业务字段置为true，表示无后续业务
                returnData.orderTradeDetailList.map((item) => {
                  if (item.checkFlag) {
                    item.checkFlag = true;
                  }
                });
              } else {
                const editStatus = ['ZT06', 'ZT05', 'ZT061', 'ZT051']; // 草稿、已驳回 ,修订中，修改已驳回 可以修改"
                if (editStatus.indexOf(returnData.contractStatus) > -1) {
                  this.disabled = false;
                }
              }
              this.exchangeRate = returnData.contractCurrencyExchangeRate;
              this.salesExchangeRate = returnData.salesCurrencyExchangeRate;
              this.baseDefault = returnData;
              this.uploadTableData = returnData.attachmentList || [];
              this.contractStatus = this.baseDefault.contractStatus;
              this.defaultBusinessType = this.baseDefault.businessType;
              // 初始化标识
              setTimeout(() => {
                this.initFlag = false;
              }, 500);
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else {
          const baseDefault = {
            contractCreateDate: dateFormat(new Date()),
            contractOperaterNo: userInfo.userCode, // 操作人：不可修改
            contractOperaterName: userInfo.userName,
            contractCompanyName: userInfo.companyName, // 公司：不可修改
            contractCompanyNo: userInfo.companyCode,
            tenantCode: userInfo.tenantCode, // 租户编码、公司、部门
            companyCode: userInfo.companyCode,
            companyName: userInfo.companyName,
            //业务公司赋初值
            contractBusinessCompanyNo: userInfo.companyCode,
            contractBusinessCompanyName: userInfo.companyName,
            departmentCode: userInfo.departmentCode,
            departmentName: userInfo.departmentName,
            contractSalesmanName: userInfo.userName,
            contractSalesmanNo: userInfo.userCode,
            contractDepartmentNo: userInfo.departmentCode,
            contractDepartmentName: userInfo.departmentName,
          };
          this.baseDefault = baseDefault;
        }
        console.log(this.baseDefault);
      },
      handleUpload(uploadTableData) {
        this.uploadTableData = uploadTableData;
      },
      handleSave() {
        this.handlePost(0);
      },
      handleSubmit() {
        const p1 = this.$refs.baseInfoForm.handleSubmit();
        const p3 = new Promise((resolve) => {
          this.$refs['productTable'].$refs['ruleTable'].validate((valid) => {
            if (valid) resolve();
          });
        });
        Promise.all([p1, p3]).then(() => {
          this.handlePost(1);
        });
      },
      async handlePost(type) {
        // type: 0保存，1提交
        // 获取基础信息值
        const baseData = this.$refs.baseInfoForm.getValues();
        // 商品明细数据：只要有商品和有合同数量的数据
        const orderTradeDetailList = this.$refs['productTable'].getValues().filter((item) => {
          return item.productNo && item.productDesc;
        });
        if (type === 1 && orderTradeDetailList.length === 0) {
          this.$message({
            showClose: true,
            message: '请添加产品明细',
            type: 'error',
          });
          return;
        }
        for (let i = 0; i < 2; i++) {
          let checkParams = {};
          if (i == 0) {
            checkParams = {
              id: baseData.id,
              purchaseExternalContractNo: baseData.purchaseExternalContractNo,
            };
          } else if (i == 1) {
            checkParams = {
              id: baseData.id,
              salesExternalContractNo: baseData.salesExternalContractNo,
            };
          }
          const p1 = await CHECK_EXTERNAL_CONTRACTNO(checkParams);
          this.load = false;
          if (!p1) return;
        }
        //如果是提交  需要校验公司本位币和合同币种是否存在
        if (
          !(
            baseData.companyCurrency &&
            baseData.settleCurrency &&
            baseData.salesCurrencyCode &&
            baseData.purchaseCurrencyCode
          ) &&
          type == '1'
        ) {
          this.$message({
            showClose: true,
            message: !baseData.companyCurrency
              ? '公司本位币不能为空'
              : !baseData.salesCurrencyCode
              ? '销售币种不能为空'
              : !baseData.purchaseCurrencyCode
              ? '采购币种不能为空'
              : '合同币种不能为空',
            type: 'error',
          });
          return;
        }
        let allTotal = this.$refs['productTable'].getTotal();
        // 利息数据
        let orderInterest = this.$refs.moneyRateForm.getValues();
        // 物流运输信息
        let orderDelivery = this.$refs.transportForm.getValues();
        baseData.type = type;
        let attachment = this.uploadTableData.map((item, index) => {
          const result = Object.assign(
            {},
            {
              sortNo: index + 1,
            },
            item
          );
          return result;
        });
        // 关联明细
        let orderContractRelationshipList = this.$refs.relationInfo.getValues();
        baseData.orderContractRelationshipListStr = JSON.stringify(orderContractRelationshipList);
        //复制过来的数据 新增时
        if (this.$route.name == 'agencyContractAdd') {
          delete orderInterest.id;
          delete orderDelivery.id;
        }
        // 复制已生效单据把运输和利息的id删除
        if (this.$route.query.isCopy) {
          delete orderInterest.id;
          delete orderDelivery.id;
        }
        baseData.orderTradeDetailListStr = JSON.stringify(orderTradeDetailList);
        baseData.orderInterestStr = JSON.stringify(orderInterest);
        baseData.orderDeliveryStr = JSON.stringify(orderDelivery);
        baseData.attachmentListStr = JSON.stringify(attachment);

        const params = Object.assign({}, baseData, allTotal, {
          dataGroup: this.$globalVar.dataGroup,
        });
        this.getCheck(params, type);
      },
      getCheck(saveParams, type) {
        let allTotal = this.$refs['productTable'].getTotal();
        const baseData = this.$refs.baseInfoForm.getValues();
        //信用额度-
        if (type == 1 && (baseData.isPrepay == '1' || baseData.isCreditsale == '1')) {
          const contractNoList = [];
          const obj = {
            businessDepartmentCode: '',
            partnerCode: '', //客户
            payAmount: '',
            contractCurrency: '',
          };
          //采购 isPrepay
          if (baseData.isPrepay == '1') {
            obj.businessDepartmentCode = baseData.contractDepartmentNo; //业务部门
            obj.partnerCode = baseData.partnerNo;
            obj.payAmount = allTotal.purchaseBusinessTotalAmount; //采购合同原币
            obj.contractCurrency = baseData.contractDepartmentNo; //币种
            contractNoList.push(obj);
          }
          //代理  isCreditsale
          if (baseData.isCreditsale == '1') {
            obj.businessDepartmentCode = baseData.contractDepartmentNo; //业务部门
            obj.partnerCode = baseData.partnerNo;
            obj.payAmount = allTotal.proxyBusinessTotalAmount; //代理合同原币
            obj.contractCurrency = baseData.salesCurrencyCode; //币种
            contractNoList.push(obj);
          }
          const params = {
            contractNoList: JSON.stringify(contractNoList),
          };
          this.load = true;
          this.$axios.post(AGENCY_API.CHECK_AVAILABLE_AMOUNT, params).then((res) => {
            this.load = false;
            if (0 != res.data.code) {
              this.$repeatConfirm(
                "<div><img src='/static/img/tips.png'/>" +
                  "<div class='repeatContent'>" +
                  '信用额度不足' +
                  '</div></div>',
                '',
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: this.$t('salePurchase.message.submitAgain'),
                  cancelButtonText: this.$t('confirm.cancel'),
                  center: true,
                  callback: (action) => {
                    if (action === 'confirm') {
                      this.saveImport(saveParams, type);
                    } else {
                      this.$message({
                        type: 'info',
                        message: this.$t('salePurchase.message.gitUpSubmitAgain'),
                      });
                    }
                  },
                }
              );
            } else {
              this.saveImport(saveParams, type);
            }
          });
        } else {
          this.saveImport(saveParams, type);
        }
      },
      saveImport(params, type) {
        this.loading.startLoading();
        this.$axios
          .post(AGENCY_API.SAVE_AGENCY_CONTRACT, params)
          .then((res) => {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              if (type == 0) {
                if (this.$route.name == 'agencyContractAdd') {
                  this.dblclickEvent(res.data.data, this.$route.query.isCopy);
                } else {
                  this.initBase();
                }
              } else {
                this.toList();
              }
            } else {
              if (this.$route.name == 'agencyContractAdd') {
                this.dblclickEvent(res.data.data, this.$route.query.isCopy);
              }
              if (!res.data.data) {
                this.$alert(res.data.msg);
              } else {
                this.$alert(res.data.msg);
                this.initBase();
              }
            }
          })
          .catch(() => {
            this.load = false;
          });
      },
      //保存--修改
      dblclickEvent(value, isCopy) {
        let path = {
          fromPath: {
            path: '/agencyContract/add',
            name: 'agencyContractAdd',
            meta: {
              keepAlive: true,
              title: this.$t('contractAgency.button.addClientBtn'),
            },
          },
          toPath: {
            path: '/agencyContract/edit',
            name: 'agencyContractEdit',
            meta: {
              keepAlive: false,
              title: this.$t('contractAgency.button.editClientBtn'),
            },
            query: {
              contractNo: value.contractNo,
              isCopy,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 处理删除
      handleDelete() {
        this.$confirmAction()
          .then(() => {
            const params = {
              ids: [this.baseDefault.id],
              contractNos: [this.baseDefault.contractNo],
            };
            this.$axios.post(AGENCY_API.BATCH_DELETE_ORDER, params).then((res) => {
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'success',
                });
                this.toList();
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {});
      },
      handleCopy() {
        this.handlePath('add', this.baseDefault.contractNo);
      },
      // 返回列表页
      toList() {
        const name = this.$route.name;
        let path = {
          fromPath: {
            path: name === 'agencyContractAdd' ? '/agencyContract/add' : '/agencyContract/edit',
            name: name === 'agencyContractAdd' ? 'agencyContractAdd' : 'agencyContractEdit',
            meta: {
              keepAlive: true,
              title: name === 'agencyContractAdd' ? '创建代理合同' : '编辑代理合同',
            },
          },
          toPath: {
            path: '/agencyContract/list',
            name: 'agencyContractList',
            meta: {
              keepAlive: false,
              title: this.$t('contractAgency.listTitle'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //打印
      handlePrint() {
        this.$refs.printDialog.openDialog(true);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .my-card {
    border: 0;
    margin-bottom: 10px;
  }
  .base-form-con {
    background: #fff;
    padding: 26px 10px 10px;
    margin-bottom: 10px;
  }
</style>
<style lang="scss">
  .common-box-card {
    border-radius: 0;
    .el-card__header {
      font-size: 14px;
      padding: 15px 20px;
      span {
        &:before {
          content: '';
          display: inline-block;
          margin-right: 10px;
          width: 4px;
          height: 15px;
          background: rgba(98, 153, 254, 1);
          border-radius: 4px;
          vertical-align: middle;
        }
      }
    }
    .el-card__body {
      padding: 26px 20px;
    }
  }
</style>
